/* eslint-disable camelcase */

import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

import sharedConstants from "@lib/shared_constants.json";

import type { SegmentsData } from "../campaigns";
import type { CampaignDateQueryKeys } from "../engagementCampaignsDataV2";
import type { EngagementSegmentFilterResult } from "../engagementSegmentData";

export interface EngagementFeatureFlagRolloutsDataParams {
  /** the unique identifier for the current app group */
  appGroupId: string;
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]> & CampaignDateQueryKeys>;
  /** the groupby column */
  groupby?: string;
  /** the number of records to return per page */
  limit?: number;
  /** the column on which to sort */
  sortby?: string;
  /** the direction in which to sort */
  sortdir?: -1 | 1;
  /** the index for the first record in the set among the entire response */
  start?: number;
}

export interface UsageData {
  canvas_steps?: {
    step_bson_id: string;
    workflow_id: string;
  }[];
  experiments?: {
    experiment_bson_id: string;
    message_variation_id: string;
  }[];
}

interface SegmentDetails {
  id: string;
  name: string;
  summary: string;
}

export interface MultiRollout {
  id: string;
  segments_data_array: SegmentsData[][];
  filters: EngagementSegmentFilterResult[] | EngagementSegmentFilterResult;
  exclusion_filters?: EngagementSegmentFilterResult;
  using_v2_filters?: boolean;
  audience_description_hash: {
    filters: string[][];
    segments: string[];
    segments_details: SegmentDetails[];
    apps: string[];
  };
  feature_flag_send_percentage: number;
}

const statuses = sharedConstants.FEATURE_FLAG.MANAGEMENT.SEARCHABLE_STATUSES;
export type FeatureFlagStatus = Exclude<(typeof statuses)[keyof typeof statuses], "all">;

export interface GetFeatureFlagRolloutsDataResponseItem extends BaseTableResultItem {
  app_group_id: string;
  audience_description_hash: {
    apps: string[];
    filters: string[];
    segments: string[];
  };
  can_be_copied_across_app_groups: boolean;
  core_rollout: {
    feature_flag_description: string;
    feature_flag_enabled: boolean;
    feature_flag_id: string;
    feature_flag_name: string;
    feature_flag_properties: string;
    feature_flag_send_percentage: number;
    rollout_id: string;
    rollout_nst: string;
  };
  created: {
    d_id: string;
    name: string;
    time: number;
  };
  created_by: string;
  filters: EngagementSegmentFilterResult[];
  id: string;
  is_archived: boolean;
  last_edit: {
    d_id: string;
    name: string;
    time: number;
  };
  last_edited: string;
  last_edited_by_id: string;
  migrated_created_at: number;
  segments_data_array: SegmentsData[][];
  tag_names: string[];
  territory_ids: string[];
  usage: UsageData;
  multi_rollouts?: MultiRollout[];
  max_multi_rollouts?: number;
  status: FeatureFlagStatus;
}

export type GetFeatureFlagRolloutsDataResponse = TableResult<GetFeatureFlagRolloutsDataResponseItem>;
